import HeroTitleComponent from "./templates/HeroTitleComponent";
import HeroBoxComponent from "./templates/HeroBoxComponent";


type REGuarantyInfoFormComponentProps = {
    
}

export default function REGuarantyInfoFormComponent({ } : Readonly<REGuarantyInfoFormComponentProps>) {

  return (
    <div className="">
      <HeroTitleComponent 
        text="QU'EST-CE QUE C'EST ?"
        icon="/img/Picto_Question_Blanc.png"
      />

      <div>
        <div className="hero-content">
            <div className="hero-illustration hide-in-mobile">
              <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Retraites.png"}></img>

            </div>
            <div className="hero-text">
                <div className="hero-text-lign">
                    <p className="hero-text-bulle"></p>
                    <p className="hero-text-info">Les contrats collectifs des agents actifs et des agents retraités du ministère de l'interieur prévoient <strong>un fonds d'aide aux retraités.</strong></p>
                </div>

                  <div className="hero-text-lign">
                    <p className="hero-text-bulle"></p>
                    <p className="hero-text-info">L'objectif de ce fonds est de <strong>prendre en charge une partie de la cotisation de la garantie socle</strong> des agents retraités les plus fragiles économiquement sur la base d'un barème tenant compte des ressources.</p>
                </div>

            </div>

        </div>
        <div className="info-box hide-in-mobile">
          <HeroBoxComponent
            text="Grâce à cette prise en charge, les agents retraités peuvent bénéficier d'une minoration de leurs cotisations."
            backgroundColor='bleu'
            icon='icon-pouce'
            iconBackgroundColor='fushia'
            position='right'
          />
        </div>
        <div className="hide-in-desktop mt-md bg-bleu blanc p-md">
          <p>Grâce à cette prise en charge, les agents retraités peuvent bénéficier d'une minoration de leurs cotisations.</p>
        </div>
      </div>
    </div>
  )
}